import useSWR from 'swr'
import { guardClient } from '../_axios'

export type ContractSummary = {
  activeContracts: string
  monthlySales: string
  monthlyProfit: string
  renewalSoon: string
}

export type ContractItem = {
  id: number
  companyName: string
  contractType: string
  period: string
  unitPrice: string
  grossProfit: string
  members: number
  owner: string
  status: '稼働中' | '更新予定' | '契約準備中'
}

type ContractsResponse = {
  data: {
    summary: ContractSummary
    contracts: ContractItem[]
  }
}

const contractsFetcher = async (
  _urlTail: string
): Promise<ContractsResponse> => {
  // const response = await guardClient.get<ContractsResponse>(_urlTail).then((r) => r.data)
  void guardClient

  return Promise.resolve({
    data: {
      summary: {
        activeContracts: '42件',
        monthlySales: '¥30.0M',
        monthlyProfit: '¥10.5M',
        renewalSoon: '8件'
      },
      contracts: [
        {
          id: 1,
          companyName: '株式会社ブルーウェーブテック',
          contractType: '準委任契約（SES）',
          period: '2024/04/01 - 2026/03/31',
          unitPrice: '¥1,800K',
          grossProfit: '¥630K',
          members: 3,
          owner: '山田太郎',
          status: '更新予定'
        },
        {
          id: 2,
          companyName: '株式会社サクラシステムズ',
          contractType: '準委任契約（SES）',
          period: '2025/10/01 - 2027/09/30',
          unitPrice: '¥2,400K',
          grossProfit: '¥840K',
          members: 4,
          owner: '佐藤花子',
          status: '稼働中'
        },
        {
          id: 3,
          companyName: '株式会社ナミエンタープライズ',
          contractType: '準委任契約（SES）',
          period: '2026/04/01 - 2027/03/31（予定）',
          unitPrice: '¥1,400K',
          grossProfit: '¥560K',
          members: 2,
          owner: '田中一郎',
          status: '契約準備中'
        }
      ]
    }
  })
}

export const useContracts = () => {
  const path = '/company/contracts'
  const { data, mutate } = useSWR(path, contractsFetcher, {
    onErrorRetry: () => {
      return
    }
  })

  return { data: data?.data, mutate }
}
